/**
 * @generated SignedSource<<1cc2e3fd01a1ae7494a0b83c941fe758>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type GraphQLSnippetCreateInput = {
  clientMutationId?: string | null;
  operationName?: string | null;
  query: string;
};
export type Console_graphQLSnippetCreateMutation$variables = {
  input: GraphQLSnippetCreateInput;
};
export type Console_graphQLSnippetCreateMutation$data = {
  readonly graphQLSnippetCreate: {
    readonly graphQLSnippet: {
      readonly url: string;
    };
  } | null;
};
export type Console_graphQLSnippetCreateMutation = {
  response: Console_graphQLSnippetCreateMutation$data;
  variables: Console_graphQLSnippetCreateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "url",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "Console_graphQLSnippetCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLSnippetCreatePayload",
        "kind": "LinkedField",
        "name": "graphQLSnippetCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLSnippet",
            "kind": "LinkedField",
            "name": "graphQLSnippet",
            "plural": false,
            "selections": [
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "Console_graphQLSnippetCreateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GraphQLSnippetCreatePayload",
        "kind": "LinkedField",
        "name": "graphQLSnippetCreate",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "GraphQLSnippet",
            "kind": "LinkedField",
            "name": "graphQLSnippet",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "28e2a20444d8e82090e79f3a27cb1ee3",
    "id": null,
    "metadata": {},
    "name": "Console_graphQLSnippetCreateMutation",
    "operationKind": "mutation",
    "text": "mutation Console_graphQLSnippetCreateMutation(\n  $input: GraphQLSnippetCreateInput!\n) {\n  graphQLSnippetCreate(input: $input) {\n    graphQLSnippet {\n      url\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "83c4622734bafce40baabe045b025eb8";

export default node;
